export default {"src":"/_next/static/media/logo-big.e8470e76.svg","height":657,"width":566};